import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { supabase } from '../lib/supabaseClient';
import { useContact } from '../context/ContactContext';
import './style/models.css';

const fallbackModels = [
  {
    id: '1',
    name: 'Aisyah Putri',
    gender: 'Female',
    type: 'kids',
    age: 8,
    height: 120,
    weight: 25,
    top_size: 'S',
    pants_size: '24',
    shoes_size: '30',
    image_1: 'https://images.unsplash.com/photo-1503919545889-aef636e10ad4?w=400&h=500&fit=crop',
    image_2: 'https://images.unsplash.com/photo-1503919545889-aef636e10ad4?w=400&h=500&fit=crop',
    image_3: 'https://images.unsplash.com/photo-1503919545889-aef636e10ad4?w=400&h=500&fit=crop',
    image_4: 'https://images.unsplash.com/photo-1503919545889-aef636e10ad4?w=400&h=500&fit=crop',
  },
  {
    id: '2',
    name: 'Budi Santoso',
    gender: 'Male',
    type: 'kids',
    age: 7,
    height: 115,
    weight: 22,
    top_size: 'S',
    pants_size: '22',
    shoes_size: '28',
    image_1: 'https://images.unsplash.com/photo-1545558014-8692077e9b5c?w=400&h=500&fit=crop',
    image_2: 'https://images.unsplash.com/photo-1545558014-8692077e9b5c?w=400&h=500&fit=crop',
    image_3: 'https://images.unsplash.com/photo-1545558014-8692077e9b5c?w=400&h=500&fit=crop',
    image_4: 'https://images.unsplash.com/photo-1545558014-8692077e9b5c?w=400&h=500&fit=crop',
  },
  {
    id: '3',
    name: 'Citra Dewi',
    gender: 'Female',
    type: 'adult',
    age: 23,
    height: 165,
    weight: 52,
    top_size: 'M',
    pants_size: '28',
    shoes_size: '38',
    image_1: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400&h=500&fit=crop',
    image_2: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400&h=500&fit=crop',
    image_3: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400&h=500&fit=crop',
    image_4: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400&h=500&fit=crop',
  },
  {
    id: '4',
    name: 'Dimas Pratama',
    gender: 'Male',
    type: 'adult',
    age: 26,
    height: 175,
    weight: 70,
    top_size: 'L',
    pants_size: '32',
    shoes_size: '42',
    image_1: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=500&fit=crop',
    image_2: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=500&fit=crop',
    image_3: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=500&fit=crop',
    image_4: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=500&fit=crop',
  },
  {
    id: '5',
    name: 'Fitri Handayani',
    gender: 'Female',
    type: 'kids',
    age: 6,
    height: 110,
    weight: 20,
    top_size: 'XS',
    pants_size: '20',
    shoes_size: '26',
    image_1: 'https://images.unsplash.com/photo-1621452773781-0f992fd1f5cb?w=400&h=500&fit=crop',
    image_2: 'https://images.unsplash.com/photo-1621452773781-0f992fd1f5cb?w=400&h=500&fit=crop',
    image_3: 'https://images.unsplash.com/photo-1621452773781-0f992fd1f5cb?w=400&h=500&fit=crop',
    image_4: 'https://images.unsplash.com/photo-1621452773781-0f992fd1f5cb?w=400&h=500&fit=crop',
  },
  {
    id: '6',
    name: 'Gilang Ramadhan',
    gender: 'Male',
    type: 'adult',
    age: 28,
    height: 180,
    weight: 75,
    top_size: 'XL',
    pants_size: '34',
    shoes_size: '44',
    image_1: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=400&h=500&fit=crop',
    image_2: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=400&h=500&fit=crop',
    image_3: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=400&h=500&fit=crop',
    image_4: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=400&h=500&fit=crop',
  },
];

function Models() {
  const { gdrive_portfolio } = useContact();
  const [models, setModels] = useState([]);
  const [filteredModels, setFilteredModels] = useState([]);
  const [activeTab, setActiveTab] = useState('all');
  const [loading, setLoading] = useState(true);
  const [selectedModel, setSelectedModel] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  useEffect(() => {
    fetchModels();
  }, []);

  useEffect(() => {
    if (activeTab === 'all') {
      setFilteredModels(models);
    } else {
      setFilteredModels(models.filter((model) => model.type === activeTab));
    }
    setCurrentPage(1); // Reset to page 1 when filter changes
  }, [activeTab, models]);

  const fetchModels = async () => {
    try {
      const { data, error } = await supabase
        .from('models')
        .select('*')
        .order('display_order', { ascending: true })
        .order('created_at', { ascending: false });

      if (error) throw error;

      if (data && data.length > 0) {
        setModels(data);
        setFilteredModels(data);
      } else {
        // Use fallback data if no data from Supabase
        setModels(fallbackModels);
        setFilteredModels(fallbackModels);
      }
    } catch (error) {
      console.log('Using fallback data:', error.message);
      setModels(fallbackModels);
      setFilteredModels(fallbackModels);
    } finally {
      setLoading(false);
    }
  };

  const handleModelClick = (model) => {
    setSelectedModel(model);
    setActiveImageIndex(0);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedModel(null);
  };

  const getModelImages = (model) => {
    return [model.image_1, model.image_2, model.image_3, model.image_4].filter(Boolean);
  };

  const handleThumbnailClick = (index) => {
    setActiveImageIndex(index);
  };

  // Pagination calculations
  const totalPages = Math.ceil(filteredModels.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredModels.slice(indexOfFirstItem, indexOfLastItem);

  // Pagination handlers
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    // Scroll to top of models section
    document.getElementById('models')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const goToFirstPage = () => handlePageChange(1);
  const goToLastPage = () => handlePageChange(totalPages);
  const goToPreviousPage = () => {
    if (currentPage > 1) handlePageChange(currentPage - 1);
  };
  const goToNextPage = () => {
    if (currentPage < totalPages) handlePageChange(currentPage + 1);
  };

  return (
    <section id="models" className="models-section">
      <Container>
        {/* Header */}
        <div className="models-header text-center">
          <h2 className="models-title">
            Our <span className="highlight">Models</span>
          </h2>
          <p className="models-subtitle">
            Meet our talented models ready for your next project
          </p>
          <hr className="models-hr" />
        </div>

        {/* Tabs and Pagination Controls Row */}
        <div className="models-controls-row">
          {/* Tabs */}
          <div className="models-tabs">
            <button
              className={activeTab === 'all' ? 'active' : ''}
              onClick={() => setActiveTab('all')}
            >
              All Models
            </button>
            <button
              className={activeTab === 'kids' ? 'active' : ''}
              onClick={() => setActiveTab('kids')}
            >
              Kids
            </button>
            <button
              className={activeTab === 'adult' ? 'active' : ''}
              onClick={() => setActiveTab('adult')}
            >
              Adult
            </button>
          </div>

          {/* Pagination Controls */}
          {!loading && totalPages > 1 && (
            <div className="pagination-controls-inline">
              <button
                className="pagination-btn"
                onClick={goToFirstPage}
                disabled={currentPage === 1}
                title="First Page"
              >
                <i className="bi bi-chevron-double-left"></i>
              </button>
              
              <button
                className="pagination-btn"
                onClick={goToPreviousPage}
                disabled={currentPage === 1}
                title="Previous Page"
              >
                <i className="bi bi-chevron-left"></i>
              </button>

              <div className="pagination-info">
                <span className="page-current">{currentPage}</span>
                <span className="page-separator">/</span>
                <span className="page-total">{totalPages}</span>
              </div>

              <button
                className="pagination-btn"
                onClick={goToNextPage}
                disabled={currentPage === totalPages}
                title="Next Page"
              >
                <i className="bi bi-chevron-right"></i>
              </button>

              <button
                className="pagination-btn"
                onClick={goToLastPage}
                disabled={currentPage === totalPages}
                title="Last Page"
              >
                <i className="bi bi-chevron-double-right"></i>
              </button>
            </div>
          )}
        </div>

        {/* Pagination Summary */}
        {!loading && totalPages > 1 && (
          <div className="pagination-summary-top">
            Showing {indexOfFirstItem + 1}-{Math.min(indexOfLastItem, filteredModels.length)} of {filteredModels.length} models
          </div>
        )}

        {/* Loading State */}
        {loading ? (
          <div className="models-loading">
            <div className="spinner"></div>
            <p>Loading models...</p>
          </div>
        ) : (
          <>
            {/* Models Grid */}
            <Row className="models-grid">
              {currentItems.map((model) => (
              <Col key={model.id} xs={12} sm={6} md={4} lg={3} className="mb-4">
                <div
                  className="model-card"
                  onClick={() => handleModelClick(model)}
                >
                  <div className="model-image-wrapper">
                    <img
                      src={model.image_1}
                      alt={model.name}
                      className="model-image"
                    />
                    <div className="model-overlay">
                      <span className="view-profile">View Profile</span>
                    </div>
                    <span className={`model-type-badge ${model.type}`}>
                      {model.type === 'kids' ? 'Kids' : 'Adult'}
                    </span>
                  </div>
                  <div className="model-info">
                    <h3 className="model-name">{model.name}</h3>
                    <p className="model-gender">{model.gender}</p>
                    <div className="model-stats">
                      <span className="stat">
                        <i className="bi bi-calendar-event"></i>
                        <span>{model.age} yo</span>
                      </span>
                      <span className="stat">
                        <i className="bi bi-rulers"></i>
                        <span>{model.height} cm</span>
                      </span>
                      <span className="stat">
                        <i className="bi bi-speedometer2"></i>
                        <span>{model.weight} kg</span>
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
            </Row>
          </>
        )}

        {/* Empty State */}
        {!loading && filteredModels.length === 0 && (
          <div className="models-empty">
            <i className="bi bi-person-x"></i>
            <p>No models found in this category</p>
          </div>
        )}

        {/* Portfolio CTA - link dari admin (GDrive Portfolio) */}
        {!loading && filteredModels.length > 0 && (
          <div className="models-portfolio-cta">
            <a
              href={gdrive_portfolio || 'https://drive.google.com/drive/folders/your-folder-id'}
              target="_blank"
              rel="noopener noreferrer"
              className="portfolio-cta-btn"
            >
              <i className="bi bi-play-circle me-2"></i>
              Click here to see EDC Portfolio Videos
              <i className="bi bi-arrow-right ms-2"></i>
            </a>
            <p className="cta-description">
              Watch our models in action with our video portfolio on Google Drive
            </p>
          </div>
        )}
      </Container>

      {/* Model Detail Modal */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        size="lg"
        className="model-modal"
      >
        {selectedModel && (
          <>
            <Modal.Header closeButton>
              <Modal.Title>{selectedModel.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col md={6}>
                  <div className="modal-images">
                    <div className="main-image-container">
                      <img
                        src={getModelImages(selectedModel)[activeImageIndex]}
                        alt={selectedModel.name}
                        className="modal-main-image"
                      />
                    </div>
                    <div className="thumbnail-gallery">
                      {getModelImages(selectedModel).map((img, index) => (
                        <div
                          key={index}
                          className={`thumbnail ${
                            activeImageIndex === index ? 'active' : ''
                          }`}
                          onClick={() => handleThumbnailClick(index)}
                        >
                          <img src={img} alt={`${selectedModel.name} ${index + 1}`} />
                        </div>
                      ))}
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="modal-details">
                    <span className={`modal-type-badge ${selectedModel.type}`}>
                      {selectedModel.type === 'kids' ? 'Kids Model' : 'Adult Model'}
                    </span>
                    <h2 className="modal-model-name">{selectedModel.name}</h2>
                    <p className="modal-gender">
                      <i className="bi bi-gender-ambiguous"></i> {selectedModel.gender}
                    </p>

                    <div className="modal-measurements">
                      <h4>Measurements</h4>
                      <div className="measurement-grid">
                        <div className="measurement-item">
                          <span className="label">Age</span>
                          <span className="value">{selectedModel.age} years</span>
                        </div>
                        <div className="measurement-item">
                          <span className="label">Height</span>
                          <span className="value">{selectedModel.height} cm</span>
                        </div>
                        <div className="measurement-item">
                          <span className="label">Weight</span>
                          <span className="value">{selectedModel.weight} kg</span>
                        </div>
                        <div className="measurement-item">
                          <span className="label">Top Size</span>
                          <span className="value">{selectedModel.top_size}</span>
                        </div>
                        <div className="measurement-item">
                          <span className="label">Pants Size</span>
                          <span className="value">{selectedModel.pants_size}</span>
                        </div>
                        <div className="measurement-item">
                          <span className="label">Shoes Size</span>
                          <span className="value">{selectedModel.shoes_size}</span>
                        </div>
                      </div>
                    </div>

                    <a
                      href={`https://wa.me/628132216607?text=Hi, saya tertarik dengan model ${selectedModel.name}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="book-model-btn"
                    >
                      <i className="bi bi-whatsapp"></i> Book This Model
                    </a>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
          </>
        )}
      </Modal>
    </section>
  );
}

export default Models;


